module.exports = __webpack_public_path__ + "onprem_38x38.bbf6c2b92d54ba38cc0af166c8310677.png";